@if (activeTab$ | async; as activeTab) {
  <div class="product-switcher">
    @if (withCreditTab) {
      <div
        class="product-switcher-option credit-option"
        mkpDataTest="switcher-credits"
        [ngClass]="{ active: activeTab === 'credits' }"
        (click)="selectCreditTab()"
      >
        <span inlineSVG="assets/icons/toll.svg" class="credit-option-logo"></span>
        <span class="hide-mobile">
          {{ 'BUTTON_TAB.CREDITS' | translate }}
        </span>
      </div>
    }
    @for (platform of platorms; track platform.name) {
      <div
        mkpDataTest="switcher-{{ platform.name }}"
        class="product-switcher-option"
        [ngClass]="{
          active:
            activePlatformGroup === platform.name && (!withCreditTab || activeTab === 'products'),
        }"
        (click)="handleSwitchPlatform(platform.name)"
      >
        <div class="product-switcher-option-content">
          <div class="product-switcher-image-container">
            <ui-asset [set]="'logos'" [name]="platform.name" [styles]="{ height: '1.25rem' }" />
          </div>
          @if (showTranslations) {
            <span>{{ platform.translationKey | translate }}</span>
          }
        </div>
      </div>
    }
  </div>
}
